import app from 'flarum/forum/app';

/**
 * Top Contributors' data, held OUTSIDE any component.
 *
 * 🚨 A widget is not mounted once — Bespoke rebuilds its zones on every
 * redraw — so a block that fetched in `oninit` would fetch, redraw, be
 * rebuilt and fetch again. One answer per period lives here, with one request
 * in flight per period, and every placement reads it.
 */

export const PERIODS = ['day', 'week', 'month', 'year'];
/** The server caches each ranking for minutes; asking again sooner is waste. */
const FRESH = 5 * 60 * 1000;
const answers = {};
const loading = {};
let chosen = null;
export function period() {
  if (chosen) return chosen;
  const setting = app.forum.attribute('concourseContributorsPeriod');
  return PERIODS.includes(setting) ? setting : 'week';
}
export function choose(next) {
  chosen = next;
  load(next);
}
export function answer(p = period()) {
  return answers[p] || null;
}
export function load(p = period()) {
  const have = answers[p];
  if (loading[p] || have && Date.now() - have.at < FRESH) return;
  loading[p] = app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/concourse/top-contributors',
    params: {
      period: p
    }
  }).then(res => {
    answers[p] = {
      metric: res.metric,
      users: Array.isArray(res.users) ? res.users : [],
      at: Date.now()
    };
  }).catch(() => {
    // Keep whatever was there; an empty list is not the same as "unknown".
    answers[p] ||= {
      metric: 'likes',
      users: [],
      at: Date.now()
    };
  }).finally(() => {
    delete loading[p];
    m.redraw();
  });
}